import React from 'react';
import Optimizer from '../../elements/Body/Optimizer/Optimizer';
import './OptimizerPage.css';
class OptimizerPage extends React.Component {
  render() {
    return (
      <>
        <Optimizer />
      </>
    );
  }
}
export default OptimizerPage;
